import Vue from 'vue'
import Vuex from 'vuex'
import { ToolButtonType } from '@/js/common.js'
import { SetCenterViewUrl } from "@/js/CommonFunc.js";

Vue.use(Vuex)

const initialState = {
  isRedirectCheck:false,
  products: [],
  currentProduct: null,
  currentCanvasData: null,
  isModal: false,
  isProductHistoryModal: false,
  currentToolItem: ToolButtonType.select,
  layerVue: null,
  isHiddenGrid: true,
  gridType: 0,
  isLoading: false,
  userTagList: [],
  userTagTemplateList: [],
  userHistoryList: [],
  mypageScreen: "",// マイページ表示時の画面遷移用
  mypageScreenTagData: {},
  agentData1: null,
  partnerData1: null,
  agentData: null,
  saleProductManager: null,
  isAlertDialog: false,
  isCartInAlertDialog: false,
  cartInAlertDialogCallback: null,
  alertMessage: "",
  alertCallback: null,
  agentCode: "",
  updataTagImage: false,
  designListData:null,
  isShowDesign:false,
  isOrderCheckModal: false,
  isLoadingMessage:false,
  isOrderTabSelected:false,
  progress:0,
  orderProcess: null,
  estimatesProcess: null,
  isShowProgress:false,
  progressMessages:[],
  bankData:null,
  isShowBankMessage:false,
  isShowLastPreview:false,
  sendBytes:0,
  isShowHelp:false,
  // sideTab:null,
  isShowYesNoDialog:false,
  yesNoDialogMessage:"",
  yesNoDialogCallback:null,
  isShowControl:false,
  isShowProductDetail:false,
  detailProduct:null,
  isShowEstimates:false,
  isShowEstimatesList:false,
  estimatesData:null,
  isEstimatesCheckModal:false,
  estimatesProductData:null,
  isShowSupport:false,
  isZoom:false,
  isBorder:false,
  isAddDifferentCategoryProduct:false,
  addDifferentCategoryProductData:null,
  isWhiteExplainDialog:false,
  isShowInputPassword:false,
  inputPasswordCallback:null,
  designImageFile: null,      // 現在編集中のものは全てファイルを保持しておく
  cutlineImageFile: null,
  scCutlineImageFile: null,
  frameCutlineImageFile: null,
  designImageURL: null,       // Uploadから他のビューへの受け渡し用
  cutlineImageURL: null,      // Uploadから他のビューへの受け渡し用
  scCutlineImageURL: null,       // シェアコードで入稿されたカットライン
  frameCutlineImageURL: null,  // シェアコードカットラインを表示用に枠線化したもの
  isShareCodeDraft: false,
  centerViewState: 6,
  previousCenterViewState: 6,
  rightViewState: 1,
  selectProductId: 0,
  isListEditMode: false,
  cartManager:null,
  draftManager:null,
  optionManager:null,
  orderHistoryManager:null,
  acrylicTicketCouponManager:null,
  campaignManager:null,
  selectBackgroundColor:1,  // プレビュー時のカラー
  selectCutlineColor:0,     // プレビュー時のカラー
  isSignature:false,        // 署名済みかどうか
  shippingScreenType:"User",
  editShippingData:null,
  isShowReOrderOption:false,
  reorderOptionCallback:null,
  isShowReOrderDesign:false,
  reorderDesignCallback:null,
  reeditDesignCallback:null,
  isShowAddCartDialog:false,
  addCartDialogCallback:null,
  currentSelectPlateNo:0,   // 編集画面で現在選択中のプレートナンバー
  selectDraftDesign:null,
  isShowInputText:false,
  inputTextProp:null, 
  isImagePopup:false,
  imagePopupImage:null,
  cardPayment:
  {
    isShow: false,
    prop: null,
    callback: null
  },

  isShowListPreview:false,
  isShowCart:false,
  isShowRightMenu:false,
  resetCameraFunc:null,
  isShowImagePreview:false,
  isShowImagesPreview:false,
  previewImageArray:[],
  isResendContractDialog: false,
  isLogout: false,
  tutorial:
  {
    isFirst: false,
    isShowBG: false,
    isShowPreview:false,
    previewStep:1,
    previewTutorialScroll:0,
    isShowShareCode:false,
    isShowEdit:false,
    editStep:1,
  },
  behalfCreateData:
  {
    selectSize:"S",
    orderNum:1,
    usePurpose:"",
    remarks:"",
    sampleData:null,
    imageData:[],
  },
  eventCreateData:
  {
    docId:"", // FirebaseのDocId（上書きに必要）
    eventName:"",
    eventIssuerName:"",
    selectSize:"S",
    userEdit:true,
    designData:null,
    cutlineData:null,
    frameCutlineImageURL:null,  // svgは画像化しておく
    nonEditableData:null,
    bannerData1:null,
    bannerData2:null,
    previewData:null,
    isEdit:null,  // 作成か編集かのフラグ
    folderName:"",  // アップロード先のフォルダー名
    isShippingFee: false, // チケット使用時に送料が存在するか
  },
  centerViewRef:null, // CenterViewの参照 スクロールの制御に使用
  firstTimeFreeData:{
    selectProductId: 0,
    selectedDestination: null,
    designImageFile: null,
    cutlineImageFile: null,
    scCutlineImageFile: null,
    designImageURL: null,
    cutlineImageURL: null,
    scCutlineImageURL: null,
  },
  commonPreviewData:{ // 汎用プレビュー用のデータ
    selectProductId:0,
    selectBackgroundColor:1,  // プレビュー時のカラー
    selectCutlineColor:0,     // プレビュー時のカラー
    designImageURL:null,
    frameCutlineImageURL:null,
  },
}
export default new Vuex.Store({
  state: {
    isRedirectCheck:false,
    products: [],
    currentProduct: null,
    currentCanvasData: null,
    isModal: false,
    isProductHistoryModal: false,
    currentToolItem: ToolButtonType.select,
    layerVue: null,
    isHiddenGrid: true,
    gridType: 0,
    isLoading: false,
    userTagList: [],
    userTagTemplateList: [],
    userHistoryList: [],
    mypageScreen: "",// マイページ表示時の画面遷移用
    mypageScreenTagData: {},
    agentData1: null,
    partnerData1: null,
    agentData: null,
    saleProductManager: null,
    isAlertDialog: false,
    isCartInAlertDialog: false,
    cartInAlertDialogCallback: null,
    isOrderCheckModal: false,
    alertMessage: "",
    alertCallback: null,
    agentCode: "",
    orderProcess: null,
    estimatesProcess: null,
    isShowDesign:false,
    isLoadingMessage:false,
    isOrderTabSelected:false,
    progress:0,
    isShowProgress:false,
    progressMessages:[],
    bankData:null,
    isShowBankMessage:false,
    isShowLastPreview:false,
    sendBytes:0,
    isShowHelp:false,
    sideTab:null,
    isShowYesNoDialog:false,
    yesNoDialogMessage:"",
    yesNoDialogCallback:null,  
    mainCanvas:null,
    isShowControl:false,
    isShowProductDetail:false,
    detailProduct:null,
    isShowEstimates:false,
    estimatesData:null,
    isShowEstimatesList:false,
    isEstimatesCheckModal:false,
    estimatesProductData:null,
    isShowSupport:false,
    homeVue:null,
    isZoom:false,
    isBorder:false,
    isAddDifferentCategoryProduct:false,
    addDifferentCategoryProductData:null,
    isWhiteExplainDialog:false,
    isShowInputPassword:false,
    inputPasswordCallback:null,
    designImageFile: null,
    cutlineImageFile: null,
    scCutlineImageFile: null,
    frameCutlineImageFile: null,
    designImageURL: null,
    cutlineImageURL: null,
    scCutlineImageURL: null,
    frameCutlineImageURL: null,
    isShareCodeDraft: false,
    centerViewState: 6,
    previousCenterViewState: 6,
    rightViewState: 0,
    selectProductId: 0,
    isListEditMode: false,
    cartManager:null,
    draftManager:null,
    optionManager:null,
    orderHistoryManager:null,
    acrylicTicketCouponManager:null,
    campaignManager:null,
    selectBackgroundColor:1,
    selectCutlineColor:0,
    isSignature:false,
    shippingScreenType:"User",
    editShippingData:null,
    isShowReOrderOption:false,
    reorderOptionCallback:null,
    isShowReOrderDesign:false,
    reorderDesignCallback:null,
    reeditDesignCallback:null,
    isShowAddCartDialog:false,
    addCartDialogCallback:null,
    currentSelectPlateNo:0,
    selectDraftDesign:null,
    isShowInputText:false,
    inputTextProp:null,  
    isImagePopup:false,
    imagePopupImage:null,
    cardPayment:
    {
      isShow: false,
      prop: null,
      callback: null
    },
    isShowListPreview:false,
    isShowCart:false,
    isShowRightMenu:false,
    resetCameraFunc:null,
    isShowImagePreview:false,
    isShowImagesPreview:false,
    previewImageArray:[],
    isResendContractDialog: false,
    isLogout: false,
    tutorial:
    {
      isFirst: false,
      isShowBG: false,
      isShowPreview:false,
      previewStep:1,
      previewTutorialScroll:0,
      isShowShareCode:false,
      isShowEdit:false,
      editStep:1,
    },
    behalfCreateData:
    {
      selectSize:"S",
      orderNum:1,
      usePurpose:"",
      remarks:"",
      sampleData:null,
      imageData:[],
    },
    eventCreateData:
    {
      docId:"", // FirebaseのDocId（上書きに必要）
      eventName:"",
      eventIssuerName:"",
      selectSize:"S",
      userEdit:true,
      designData:null,
      cutlineData:null,
      frameCutlineImageURL:null,
      nonEditableData:null,
      bannerData1:null,
      bannerData2:null,
      previewData:null,
      isEdit:null,  // 作成か編集かのフラグ
      folderName:"",  // アップロード先のフォルダー名
      isShippingFee: false, // チケット使用時に送料が存在するか
    },
    centerViewRef:null,
    firstTimeFreeData:{
      selectProductId: 0,
      selectedDestination: null,
      designImageFile: null,
      cutlineImageFile: null,
      scCutlineImageFile: null,
      designImageURL: null,
      cutlineImageURL: null,
      scCutlineImageURL: null,
    },
    commonPreviewData:{ // 汎用プレビュー用のデータ
      selectProductId:0,
      selectBackgroundColor:1,  // プレビュー時のカラー
      selectCutlineColor:0,     // プレビュー時のカラー
      designImageURL:null,
      frameCutlineImageURL:null,
    },
  },
  mutations: {
    setRedirectCheck(state,item){
      state.isRedirectCheck = item
    },
    resetData(state) {
      Object.assign(state, initialState)
    },
    addProduct(state, product) {
      this.state.products.push(product);
      this.state.currentProduct = product;
      this.state.isZoom = false
    },
    removeProduct: function (state, product) {
      if (product === this.state.currentProduct) {
        this.state.currentProduct = null
        this.state.currentCanvasData = null
      }
      this.state.products = this.state.products.filter(function (a) {
        return a !== product;
      });
    },
    removeCurrentProductCanvasItem(state, item) {
      this.state.currentCanvasData.itemList = this.state.currentCanvasData.itemList.filter(function (a) {
        return a !== item;
      });
    },
    downCurrentProductCanvasItem(state, item) {
      let index = this.state.currentCanvasData.itemList.indexOf(item)
      if (index <= 0) {
        return
      }
      this.state.currentCanvasData.itemList.splice(index - 1, 0, item)
      this.state.currentCanvasData.itemList.splice(index + 1, 1)

    },
    upCurrentProductCanvasItem(state, item) {
      let index = this.state.currentCanvasData.itemList.indexOf(item)
      this.state.currentCanvasData.itemList.splice(index + 2, 0, item)
      this.state.currentCanvasData.itemList.splice(index, 1)

    },
    selectProduct(state, product) {
      state.currentProduct = product;
    },
    selectCanvasData(state, canvasData) {
      state.currentCanvasData = canvasData;
    },
    showModal(state) {
      state.isModal = true;
    },
    hideModal(state) {
      state.isModal = false;
    },
    showLoading(state,item = false) {
      state.isLoading = true;
      state.isLoadingMessage = item
    },
    showLoadingMessage(state,message){
      state.isLoading = true;
      state.isLoadingMessageFree = message
    },
    updateLoadingMessage(state,message){
      state.isLoadingMessageFree = message
    },
    hideLoading(state) {
      state.isLoading = false;
      state.isLoadingMessage = false
      state.isLoadingMessageFree = ""
    },
    setAlertDialogCallback(state, callback){
      state.alertCallback = callback;
    },
    showMessage(state, message) {
      state.isAlertDialog = true;
      state.alertMessage = message
    },
    hideMessage(state) {
      state.isAlertDialog = false;
      state.alertCallback = null;
      state.alertMessage = ""
    },
    showCartInDialog(state, callback) {
      state.isCartInAlertDialog = true;
      state.cartInAlertDialogCallback = callback;
    },
    hideCartInDialog(state) {
      state.isCartInAlertDialog = false;
      state.cartInAlertDialogCallback = null;
    },
    // showMypageModal(state) {
    //   state.isMypageModal = true;
    // },
    // hideMypageModal(state) {
    //   state.isMypageModal = false;
    // },
    showProductHistoryModal(state) {
      state.isProductHistoryModal = true;
    },
    hideProductHistoryModal(state) {
      state.isProductHistoryModal = false;
    },
    setCurrentToolItem(state, item) {
      state.currentToolItem = item;
    },
    setLayerVue(state, item) {
      state.layerVue = item
    },
    switchGrid(state) {
      state.gridType += 1
      if(state.gridType == 3){
        state.gridType = 0
        state.isHiddenGrid = true
      } else {
        state.isHiddenGrid = false
      }
    },
    setUserTagData(state, item) {
      state.userTagList = item
    },
    setUserTagTemplateData(state, item) {
      state.userTagTemplateList = item
    },
    setUserHistoryData(state, item) {
      state.userHistoryList = item
    },
    setMypageScreen(state, name) {
      state.mypageScreen = name
    },
    resetMypageScreen(state) {
      state.mypageScreen = ""
    },
    setMypageScreenTagData(state, data) {
      state.mypageScreenTagData = data
    },
    resetMypageScreenTagData(state) {
      state.mypageScreenTagData = {}
    },
    setAgentData1(state, item) {
      state.agentData1 = item
    },
    setAgentData(state, item) {
      state.agentData = item
    },
    setPartnerData1(state, item) {
      state.partnerData1 = item
    },
    setSaleProductManager(state, item) {
      state.saleProductManager = item
    },
    setAgentCode(state, item) {
      state.agentCode = item
    },
    showOrderCheck(state) {
      state.isOrderCheckModal = true
    },
    hideOrderCheck(state) {
      state.isOrderCheckModal = false
    },
    showEstimatesCheck(state) {
      state.isEstimatesCheckModal = true
    },
    hideEstimatesCheck(state) {
      state.isEstimatesCheckModal = false
    },
    setOrderProcess(state, item) {
      state.orderProcess = item
    },
    setEstimatesProcess(state, item) {
      state.estimatesProcess = item
    },
    resetCart(state) {
      state.currentCanvasData = null
      this.state.products = []
      this.state.currentProduct = null
    },
    showDesign(state,data){
      state.designListData = data
      state.isShowDesign = true
    },
    hideDesign(state){
      state.isShowDesign = false
    },
    setOrderTabSelect(state,item){
      state.isOrderTabSelected = item
    },
    setProgress(state,item){
      state.progress = item
    },
    setProgressMessages(state,item){
      state.progressMessages = item
    },
    showProgress(state){
      state.isShowProgress = true
    },
    hideProgress(state){
      state.isShowProgress = false
      state.progress = 0
      state.progressMessages = []
    },
    showBankData(state,item){
      state.isShowBankMessage = true
      state.bankData = item
    },
    hideBankData(state){
      state.isShowBankMessage = false
      state.bankData = null
    },
    showLastPreview(state){
      state.isShowLastPreview = true
    },
    hideLastPreview(state){
      state.isShowLastPreview = false
    },
    setSendBytes(state,item){
      state.sendBytes = item
    },
    showHelp(state){
      state.isShowHelp = true
    },
    hideHelp(state){
      state.isShowHelp = false
    },
    setSideTab(state,item){
      state.sideTab = item
    },
    showYesNoDialog(state,message){
      state.isShowYesNoDialog = true
      state.yesNoDialogMessage = message
    },
    setYesNoDialogCallback(state,callback){
      state.yesNoDialogCallback = callback
    },
    hideYesNoDialog(state){
      state.isShowYesNoDialog = false
      state.yesNoDialogMessage = ""
      state.yesNoDialogCallback = null
    },
    setMainCanvas(state,item){
      state.mainCanvas = item
    },
    showControl(state){
      state.isShowControl = true
    },
    hideControl(state){
      state.isShowControl = false
    },
    showProductDetail(state,item){
      state.isShowProductDetail = true
      state.detailProduct = item
    },
    hideProductDetail(state){
      state.isShowProductDetail = false
      state.detailProduct = null
    },
    showEstimates(state,data){
      state.isShowEstimates = true
      state.estimatesData = data
    },
    hideEstimates(state){
      state.isShowEstimates = false
      state.estimatesData = null
      state.estimatesProductData = null
    },
    showEstimatesList(state){
      state.isShowEstimatesList = true
    },
    hideEstimatesList(state){
      state.isShowEstimatesList = false
    },
    setEstimatesProductData(state,item){
      state.estimatesProductData = item
    },
    showSupport(state){
      state.isShowSupport = true
    },
    hideSupport(state){
      state.isShowSupport = false
    },
    showWhiteExplainDialog(state){
      state.isWhiteExplainDialog = true
    },
    hideWhiteExplainDialog(state){
      state.isWhiteExplainDialog = false
    },
    setHome(state,item){
      state.homeVue = item
    },
    setZoom(state,flag){
      state.isZoom = flag
    },
    setBorder(state,flag){
      state.isBorder = flag
    },
    showAddDifferentCategoryProduct(state,data){
      state.addDifferentCategoryProductData = data
      state.isAddDifferentCategoryProduct = true
    },
    hideAddDifferentCategoryProduct(state){
      state.isAddDifferentCategoryProduct = false
    },
    showInputPassword(state,callback) {
      state.isShowInputPassword = true
      state.inputPasswordCallback = callback
    },
    hideInputPassword(state) {
      state.isShowInputPassword = false
      state.inputPasswordCallback = null
    },
    setDesignImageFile(state, file){
      state.designImageFile = file;
    },
    setCutlineImageFile(state, file){
      state.cutlineImageFile = file;
    },
    setScCutlineImageFile(state, file){
      state.scCutlineImageFile = file;
    },
    setFrameCutlineImageFile(state, file){
      state.frameCutlineImageFile = file;
    },
    setDesignImageURL(state, url){
      state.designImageURL = url;
    },
    setCutlineImageURL(state, url){
      state.cutlineImageURL = url;
    },
    setScCutlineImageURL(state, url){
      state.scCutlineImageURL = url;
    },
    setFrameCutlineImageURL(state, url){
      state.frameCutlineImageURL = url;
    },
    setIsShareCodeDraft( state, isShareCode ){
      state.isShareCodeDraft = isShareCode;
    },
    setCenterViewState(state, viewState){
      state.previousCenterViewState = state.centerViewState;
      state.centerViewState = viewState;
      SetCenterViewUrl(state.centerViewState);
    },
    setPreviousCenterViewState(state){
      state.centerViewState = state.previousCenterViewState;
      SetCenterViewUrl(state.centerViewState);
    },
    setRightViewState(state, viewState){
      state.rightViewState = viewState;
    },
    setSelectProductId(state, id){
      state.selectProductId = id;
    },
    setListEditMode(state, isListEdit){
      state.isListEditMode = isListEdit;
    },
    setCartManager(state, item) {
      state.cartManager = item
    },
    setDraftManager(state, item) {
      state.draftManager = item
    },
    setSelectBackgroundColor(state, id){
      state.selectBackgroundColor = id;
    },
    setSelectCutlineColor(state, id){
      state.selectCutlineColor = id;
    },
    setIsSignature(state, f){
      state.isSignature = f;
    },
    setOptionManager(state, item) {
      state.optionManager = item
    },
    setOrderHistoryManager(state, item) {
      state.orderHistoryManager = item
    },
    setAcrylicTicketCouponManager(state, item) {
      state.acrylicTicketCouponManager = item
    },
    setCampaignManager(state, item) {
      state.campaignManager = item
    },
    setShippingScreenType(state, item) {
      state.shippingScreenType = item
    },
    setEditShippingData(state, item) {
      state.editShippingData = item
    },
    setReorderOption(state,item) {
      state.isShowReOrderOption = item
    },
    setReorderOptionCallback(state,callback){
      state.reorderOptionCallback = callback
    },
    setReorderDesign(state,item) {
      state.isShowReOrderDesign = item
    },
    setReorderDesignCallback(state,{reorder, reedit}){
      state.reorderDesignCallback = reorder
      state.reeditDesignCallback = reedit
    },
    setAddCartDialog(state, {isShow, callback}) {
      state.isShowAddCartDialog = isShow
      state.addCartDialogCallback = callback
    },
    setCurrentSelectPlateNo(state, no){
      state.currentSelectPlateNo = no;
    },
    setSelectDraftDesign(state, design){
      state.selectDraftDesign = design
    },
    showInputText(state,prop) {
      state.isShowInputText = true;
      state.inputTextProp = prop
    },
    hideInputText(state) {
      state.inputTextProp = null
      state.isShowInputText = false;
    },
    showImagePopup(state,image){
      state.isImagePopup = true
      state.imagePopupImage = image
    },
    hideImagePopup(state) {
      state.isImagePopup = false
    },
    setCardPaymentCallback( state, callback ){
      state.cardPayment.callback = callback;
    },
    showCardPayment(state,cardPaymentProp){
      state.cardPayment.isShow = true
      state.cardPayment.prop = cardPaymentProp
    },
    hideCardPayment(state) {
      state.cardPayment.isShow = false
      state.cardPayment.callback = null;
      state.cardPayment.prop = null
    },
    showListPreview(state){
      state.isShowListPreview = true
    },
    hideListPreview(state){
      state.isShowListPreview = false
    },
    switchShowCart(state) {
      state.isShowCart = !state.isShowCart
    },
    showRightMenu(state) {
      state.isShowRightMenu = true;
    },
    hideRightMenu(state) {
      state.isShowRightMenu = false;
    },
    setResetCameraFunc(state, func){
      state.resetCameraFunc = func;
    },
    showImagePreview(state,image){
      state.isShowImagePreview = true
      state.previewImageArray = [image]
    },
    hideImagePreview(state) {
      state.isShowImagePreview = false
      state.previewImageArray = null
    },
    showImagsPreview(state,images){
      state.isShowImagesPreview = true
      state.previewImageArray = images
    },
    hideImagesPreview(state) {
      state.isShowImagesPreview = false
      state.previewImageArray = null
    },
    setIsFirstTutorial(state, flag){
      state.tutorial.isFirst = flag
    },
    setPreviewTutorialScroll(state, scroll){
      state.tutorial.previewTutorialScroll = scroll
    },
    showPreviewTutorial(state, step = 1){
      state.tutorial.isShowBG = true
      state.tutorial.isShowPreview = true
      state.tutorial.previewStep = step
    },
    hidePreviewTutorial(state){
      state.tutorial.isShowBG = false
      state.tutorial.isShowPreview = false
    },
    previewTutorialNextStep(state){
      state.tutorial.previewStep += 1
    },
    showResendContractDialog(state){
      state.isResendContractDialog = true;
    },
    hideResendContractDialog(state){
      state.isResendContractDialog = false;
    },
    logout(state){
      state.isLogout = true;
    },
    showShareCodeTutorial(state){
      state.tutorial.isShowBG = true
      state.tutorial.isShowShareCode = true
    },
    hideShareCodeTutorial(state){
      state.tutorial.isShowBG = false
      state.tutorial.isShowShareCode = false
    },
    showEditTutorial(state, step = 1){
      state.tutorial.isShowBG = true
      state.tutorial.isShowEdit = true
      state.tutorial.editStep = step
    },
    hideEditTutorial(state){
      state.tutorial.isShowBG = false
      state.tutorial.isShowEdit = false
    },
    editTutorialNextStep(state){
      state.tutorial.editStep += 1
    },
    resetBehalfCreateData(state){
      state.behalfCreateData =
      {
        selectSize:"S",
        orderNum:1,
        usePurpose:"",
        remarks:"",
        sampleData:null,
        imageData:[],
      }
    },
    setBehalfCreateSampleData(state, fileKit){
      state.behalfCreateData.sampleData = fileKit;
    },

    addBehalfCreateImageData(state, fileKit){
      state.behalfCreateData.imageData.push(fileKit);
    },

    deleteBehalfCreateImageData(state, index){
      state.behalfCreateData.imageData.splice(index, 1);
    },
    resetEventCreateData(state){
      state.eventCreateData =
      {
        docId:"", // FirebaseのDocId（上書きに必要）
        eventName:"",
        eventIssuerName:"",
        selectSize:"S",
        userEdit:true,
        designData:null,
        cutlineData:null,
        frameCutlineImageURL:null,
        nonEditableData:null,
        bannerData1:null,
        bannerData2:null,
        previewData:null,
        isEdit:false,
        folderName:"",
        isShippingFee: false,
      }
    },
    setEventCreateDocId(state, id){
      state.eventCreateData.docId = id;
    },
    setEventCreateEventName(state, name){
      state.eventCreateData.eventName = name;
    },
    setEventCreateEventIssuerName(state, name){
      state.eventCreateData.eventIssuerName = name;
    },
    setEventCreateEventSelectSize(state, size){
      state.eventCreateData.selectSize = size;
    },
    setEventCreateEventUserEdit(state, edit){
      state.eventCreateData.userEdit = edit;
    },
    setEventCreateDesignData(state, fileKit){
      state.eventCreateData.designData = fileKit;
    },
    setEventCreateCutlineData(state, fileKit){
      state.eventCreateData.cutlineData = fileKit;
    },
    setEventCreateCutlineImageURL(state, url){
      state.eventCreateData.frameCutlineImageURL = url;
    },
    setEventCreateNonEditableData(state, fileKit){
      state.eventCreateData.nonEditableData = fileKit;
    },
    setEventCreateBannerData1(state, fileKit){
      state.eventCreateData.bannerData1 = fileKit;
    },
    setEventCreateBannerData2(state, fileKit){
      state.eventCreateData.bannerData2 = fileKit;
    },
    setEventCreatePreviewData(state, fileKit){
      state.eventCreateData.previewData = fileKit;
    },
    setEventCreateEventIsEdit(state, isEdit){
      state.eventCreateData.isEdit = isEdit;
    },
    setEventCreateEventFolderName(state, name){
      state.eventCreateData.folderName = name;
    },
    setEventCreateEventIsShippingFee(state, shippingFee){
      state.eventCreateData.isShippingFee = shippingFee;
    },
    setCenterViewRef(state, ref){
      state.centerViewRef = ref;
    },
    resetFirstTimeFreeData(state){
      state.firstTimeFreeData =
      {
        selectProductId: 0,
        selectedDestination: null,
        designImageFile: null,
        cutlineImageFile: null,
        scCutlineImageFile: null,
        designImageURL: null,
        cutlineImageURL: null,
        scCutlineImageURL: null,
      }
    },
    setFirstTimeFreeSelectProductId(state, id){
      state.firstTimeFreeData.selectProductId = id;
    },
    setFirstTimeFreeSelectDestination(state, destination){
      state.firstTimeFreeData.selectedDestination = destination;
    },
    setFirstTimeFreeDesignImageFile(state, file){
      state.firstTimeFreeData.designImageFile = file;
    },
    setFirstTimeFreeCutlineImageFile(state, file){
      state.firstTimeFreeData.cutlineImageFile = file;
    },
    setFirstTimeFreeScCutlineImageFile(state, file){
      state.firstTimeFreeData.scCutlineImageFile = file;
    },
    setFirstTimeFreeDesignImageURL(state, url){
      state.firstTimeFreeData.designImageURL = url;
    },
    setFirstTimeFreeCutlineImageURL(state, url){
      state.firstTimeFreeData.cutlineImageURL = url;
    },
    setFirstTimeFreeScCutlineImageURL(state, url){
      state.firstTimeFreeData.scCutlineImageURL = url;
    },
    resetCommonPreviewData(state){
      state.commonPreviewData =
      {
        selectProductId:0,
        selectBackgroundColor:1,  // プレビュー時のカラー
        selectCutlineColor:0,     // プレビュー時のカラー
        designImageURL:null,
        frameCutlineImageURL:null,
      }
    },
    setCommonPreviewSelectProductId(state, id){
      state.commonPreviewData.selectProductId = id;
    },
    setCommonSelectBackgroundColor(state, id){
      state.commonPreviewData.selectBackgroundColor = id;
    },
    setCommonSelectCutlineColor(state, id){
      state.commonPreviewData.selectCutlineColor = id;
    },
    setCommonDesignImageURL(state, url){
      state.commonPreviewData.designImageURL = url;
    },
    setCommonFrameCutlineImageURL(state, url){
      state.commonPreviewData.frameCutlineImageURL = url;
    },
  },
  actions: {
  },
  modules: {
  }
})
